import { render, staticRenderFns } from "./blok-button.vue?vue&type=template&id=3e0102da&scoped=true&"
import script from "./blok-button.vue?vue&type=script&lang=js&"
export * from "./blok-button.vue?vue&type=script&lang=js&"
import style0 from "./blok-button.vue?vue&type=style&index=0&id=3e0102da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0102da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0102da')) {
      api.createRecord('3e0102da', component.options)
    } else {
      api.reload('3e0102da', component.options)
    }
    module.hot.accept("./blok-button.vue?vue&type=template&id=3e0102da&scoped=true&", function () {
      api.rerender('3e0102da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-button.vue"
export default component.exports